var map = {
	"./star1.png": "d237",
	"./star1_sm.png": "a7c3",
	"./star2.png": "8d84",
	"./star2_sm.png": "a039",
	"./star3.png": "3561",
	"./star3_sm.png": "f450",
	"./star4.png": "e57e",
	"./star4_sm.png": "e2fa",
	"./stars.png": "ec0e",
	"./stars_sm.png": "4d8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f02f";